import { Modal } from 'bootstrap';
import { sendHelpRequest } from './help-service';
import { isDjangoEditMode } from '../cms';

const HELP_MODAL_ID = 'advisorHelpModal';
const HELP_MODAL_CONTINUE_BUTTON_ID = 'advisorHelpModalContinueButton';

function initHelpModalTrigger(link: HTMLAnchorElement) {
  link.addEventListener('click', (event) => {
    if (!isDjangoEditMode()) {
      event.preventDefault();
      const { modalTarget } = link.dataset;

      if (!modalTarget) return;

      const modalElement = document.querySelector(modalTarget);

      if (!modalElement) return;

      Modal.getInstance(modalElement)?.show();
    }
  });
}

function updateActionButton() {
  const button = document.getElementById(HELP_MODAL_CONTINUE_BUTTON_ID) as HTMLButtonElement | null;
  if (!button) return;
  button.textContent = 'Enviando tu solicitud...';
  button.disabled = true;
}

function resetActionButton() {
  const button = document.getElementById(HELP_MODAL_CONTINUE_BUTTON_ID) as HTMLButtonElement | null;
  if (!button) return;
  button.textContent = 'Continuar';
  button.disabled = false;
}

type ModalContentState = 'initial' | 'success' | 'error';

function setModalContent(state: ModalContentState) {
  const content = document.getElementById('advisorHelpModalContent');
  const successContent = document.getElementById('advisorHelpModalSuccessContent');
  const errorContent = document.getElementById('advisorHelpModalErrorContent');

  content?.classList.toggle('d-none', state !== 'initial');
  successContent?.classList.toggle('d-none', state !== 'success');
  errorContent?.classList.toggle('d-none', state !== 'error');
}

function initActionButton() {
  const button = document.getElementById(HELP_MODAL_CONTINUE_BUTTON_ID);
  button?.addEventListener('click', () => {
    updateActionButton();
    sendHelpRequest()
      .then(() => {
        setModalContent('success');
      })
      .catch(() => {
        resetActionButton();
        setModalContent('error');
      });
  });
}

window.addEventListener('DOMContentLoaded', () => {
  const helpModalTriggers = document.querySelectorAll<HTMLAnchorElement>('[data-toggle="help-modal"]');

  helpModalTriggers.forEach(initHelpModalTrigger);
  initActionButton();

  const modalElement = document.getElementById(HELP_MODAL_ID);
  if (modalElement) {
    modalElement.addEventListener('show.bs.modal', () => {
      setModalContent('initial');
      resetActionButton();
    });
  }
});
